<div class="main-wrapper">
    <div class="logo">
        <a href="/">
            <img
                    src="assets/images/logo.png"
                    class="brand-logo me-4"
                    alt="brand"
            >
        </a>
    </div>
    <div class="container inner-content">
        <div class="row">
            <div class="col-12">
                <div class="wrapper text-white">
                    <h1>{{ 'ERROR_PAGE.TITLE' | translate }}</h1>
                    <h2>{{ 'ERROR_PAGE.SUB_TITLE' | translate }}</h2>
                    <p>{{ 'ERROR_PAGE.TEXT1' | translate }}</p>
                    <span>{{ 'ERROR_PAGE.TEXT2' | translate }}</span>
                    <a
						href="/"
                            mat-flat-button
                            color="primary"
                            class="btn btn-primary"
                            type="button"
                            id="button"
                    >{{ 'ERROR_PAGE.BUTTON' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <footer>
                    <ul>
                        <li>
                            <a [href]="mainSiteUrl">alaric.bg</a>
                        </li>
                        <li>
                            <a href="mailto:sales@alaric.bg">sales@alaric.bg</a>
                        </li>
                    </ul>
                </footer>
            </div>
        </div>
    </div>
</div>
